export const baseurl = "https://intelligentsia.onrender.com";

export enum userlist{
	following,
     followers,
     home
};

export enum tweetlist {
     home,
     authored,
     liked
};